const productData = [
  {
    id: 1,
    name: "Forma Ring Agenda — Espresso",
    category: "Planners",
    price: "148.00",
    reviews: "86",
    rating: "4.9",
    image: "/img/generated/product-01.jpg",
    images: ["/img/generated/product-01.jpg"],
    size: ["Personal", "A5"],
    colors: ["Espresso"],
    material: "Full-grain pebbled leather and gold-tone steel",
    description: [
      "A softly structured ring agenda in deep espresso leather, designed to make daily planning feel considered and calm.",
      "Six precision rings, sculpted pockets, and a lay-flat spine keep schedules, notes, and keepsakes beautifully ordered.",
    ],
    attributes: {
      format: "Six-ring agenda",
      closure: "Hidden magnetic tab",
      interior: "Card slots, document pocket, pen loop",
      compatibility: "Personal and A5 six-hole inserts",
    },
    tags: ["leather", "ring agenda", "best-seller", "planner-system", "new", "espresso"],
    Features: [
      "Hand-finished leather exterior",
      "Replaceable ring mechanism",
      "Lay-flat reinforced spine",
      "Protective cotton dust bag included",
    ],
  },
  {
    id: 2,
    name: "Forma Ring Agenda — Bone",
    category: "Planners",
    price: "148.00",
    reviews: "72",
    rating: "4.8",
    image: "/img/generated/product-02-v2.png",
    images: ["/img/generated/product-02-v2.png"],
    size: ["Personal", "A5"],
    colors: ["Bone"],
    material: "Full-grain pebbled leather and silver-tone steel",
    description: [
      "Our signature ring agenda rendered in a warm bone neutral that moves effortlessly from desk to meeting room.",
      "The refined interior offers flexible organization without visual clutter, leaving space for a planning system of your own.",
    ],
    attributes: {
      format: "Six-ring agenda",
      closure: "Hidden magnetic tab",
      interior: "Card slots, document pocket, pen loop",
      compatibility: "Personal and A5 six-hole inserts",
    },
    tags: ["leather", "ring agenda", "planner-system", "neutral", "bone"],
    Features: [
      "Tonal edge painting",
      "Replaceable ring mechanism",
      "Lay-flat reinforced spine",
      "Protective cotton dust bag included",
    ],
  },
  {
    id: 3,
    name: "Meridian Discbound Planner — Black",
    category: "Planners",
    price: "72.00",
    reviews: "118",
    rating: "4.9",
    image: "/img/generated/product-03.jpg",
    images: ["/img/generated/product-03.jpg"],
    size: ["Half Letter", "Mini"],
    colors: ["Matte Black"],
    material: "Vegan leather, heavyweight paper, aluminum discs",
    description: [
      "A streamlined discbound planner built for ideas that evolve, with pages that can be removed, reordered, and returned in seconds.",
      "Minimal weekly layouts and matte black covers create a focused workspace for projects, priorities, and appointments.",
    ],
    attributes: {
      format: "Discbound planner",
      layout: "Undated weekly and monthly",
      paperWeight: "120 gsm",
      pageCount: "160 pages",
    },
    tags: ["discbound", "undated", "best-seller", "planner-system", "black", "productivity"],
    Features: [
      "Six months of undated planning pages",
      "Repositionable premium paper",
      "Eight aluminum discs",
      "Elastic closure band",
    ],
  },
  {
    id: 4,
    name: "Weekly Focus Inserts — A5",
    category: "Planner Inserts",
    price: "52.00",
    reviews: "164",
    rating: "4.9",
    image: "/img/generated/product-04.jpg",
    images: ["/img/generated/product-04.jpg"],
    size: ["A5"],
    colors: ["Soft White"],
    material: "Responsibly sourced 120 gsm paper",
    description: [
      "An undated week-on-two-pages layout with generous room for priorities, appointments, and quiet notes.",
      "Subtle gray typography keeps the page calm while a focused sidebar brings the week’s most important work forward.",
    ],
    attributes: {
      format: "Six-hole punched inserts",
      layout: "Monday start, week on two pages",
      paperWeight: "120 gsm",
      pageCount: "60 pages / 30 weeks",
    },
    tags: ["weekly", "A5", "inserts", "best-seller", "new", "undated"],
    Features: [
      "Fountain-pen-friendly paper",
      "Priority and notes sections",
      "Minimal monochrome print",
      "Fits standard A5 six-ring agendas",
    ],
  },
  {
    id: 5,
    name: "Daily Notes Inserts — A5",
    category: "Planner Inserts",
    price: "54.00",
    reviews: "139",
    rating: "4.8",
    image: "/img/generated/product-05.jpg",
    images: ["/img/generated/product-05.jpg"],
    size: ["A5"],
    colors: ["Soft White"],
    material: "Responsibly sourced 120 gsm paper",
    description: [
      "A spacious daily page that balances a timed schedule with tasks, notes, and one intentional daily focus.",
      "The undated format lets you plan only the days that need structure, with no abandoned pages or visual noise.",
    ],
    attributes: {
      format: "Six-hole punched inserts",
      layout: "One day per page",
      paperWeight: "120 gsm",
      pageCount: "60 pages",
    },
    tags: ["daily", "A5", "inserts", "new", "time blocking"],
    Features: [
      "Hourly schedule from 7 AM to 9 PM",
      "Dedicated task and notes columns",
      "Undated for flexible use",
      "Fits standard A5 six-ring agendas",
    ],
  },
  {
    id: 6,
    name: "Project Map Inserts",
    category: "Planner Inserts",
    price: "49.00",
    reviews: "68",
    rating: "4.7",
    image: "/img/generated/product-06.jpg",
    images: ["/img/generated/product-06.jpg"],
    size: ["Personal", "A5"],
    colors: ["Soft White"],
    material: "Responsibly sourced 120 gsm paper",
    description: [
      "Turn an open-ended idea into a clear sequence of milestones, owners, next actions, and notes.",
      "Each two-page project map offers enough structure to create momentum while remaining adaptable to creative or professional work.",
    ],
    attributes: {
      format: "Six-hole punched inserts",
      layout: "Two-page project spread",
      paperWeight: "120 gsm",
      projectCount: "15 projects",
    },
    tags: ["projects", "inserts", "goals", "planning"],
    Features: [
      "Milestone and action planning",
      "Space for deadlines and collaborators",
      "Minimal grid note area",
      "Available in Personal and A5 sizes",
    ],
  },
  {
    id: 7,
    name: "Monthly Index Dividers",
    category: "Dividers & Dashboards",
    price: "56.00",
    reviews: "101",
    rating: "4.8",
    image: "/img/generated/product-07.jpg",
    images: ["/img/generated/product-07.jpg"],
    size: ["Personal", "A5"],
    colors: ["Warm Gray"],
    material: "Laminated archival cardstock",
    description: [
      "Twelve slim monthly dividers create an intuitive rhythm through the year without adding unnecessary bulk.",
      "Warm gray tabs and restrained typography pair naturally with neutral covers, clear dashboards, and monochrome inserts.",
    ],
    attributes: {
      format: "January–December tab set",
      finish: "Soft-touch matte laminate",
      edge: "Rounded outer corners",
      punch: "Six-hole punched",
    },
    tags: ["dividers", "monthly", "tabs", "new", "organization"],
    Features: [
      "Twelve labeled monthly tabs",
      "Wipe-clean matte finish",
      "Reinforced punched edge",
      "Available in Personal and A5 sizes",
    ],
  },
  {
    id: 8,
    name: "Translucent Dashboard Set",
    category: "Dividers & Dashboards",
    price: "58.00",
    reviews: "95",
    rating: "4.8",
    image: "/img/generated/product-08.jpg",
    images: ["/img/generated/product-08.jpg"],
    size: ["Personal", "A5", "Half Letter"],
    colors: ["Smoke", "Frost", "Sand"],
    material: "Recycled translucent polypropylene",
    description: [
      "A trio of translucent dashboards that layers soft architectural color over the pages beneath.",
      "Use each sheet as a section marker, writing guard, or visual pause within ring and discbound systems.",
    ],
    attributes: {
      quantity: "Set of three",
      finish: "Matte translucent",
      thickness: "0.4 mm",
      compatibility: "Ring and discbound formats",
    },
    tags: ["dashboard", "translucent", "layering", "neutral"],
    Features: [
      "Three complementary neutral tones",
      "Durable wipe-clean surface",
      "Pre-punched for selected format",
      "Rounded snag-free corners",
    ],
  },
  {
    id: 9,
    name: "Everyday Notebook — Stone",
    category: "Notebooks",
    price: "63.00",
    reviews: "124",
    rating: "4.9",
    image: "/img/generated/product-09.jpg",
    images: ["/img/generated/product-09.jpg"],
    size: ["A5"],
    colors: ["Stone"],
    material: "Book cloth and responsibly sourced 100 gsm paper",
    description: [
      "A clothbound notebook for lists, observations, meeting notes, and ideas worth returning to.",
      "Its pale stone cover, lay-flat binding, and understated dot grid bring a composed feel to everyday writing.",
    ],
    attributes: {
      binding: "Thread-sewn lay-flat",
      ruling: "5 mm dot grid",
      paperWeight: "100 gsm",
      pageCount: "192 numbered pages",
    },
    tags: ["notebook", "dot grid", "clothbound", "best-seller", "stone"],
    Features: [
      "Two ribbon page markers",
      "Expandable rear pocket",
      "Fountain-pen-friendly paper",
      "Foil-stamped spine detail",
    ],
  },
  {
    id: 10,
    name: "Spiral Studio Notebook",
    category: "Notebooks",
    price: "59.00",
    reviews: "83",
    rating: "4.7",
    image: "/img/generated/product-10.jpg",
    images: ["/img/generated/product-10.jpg"],
    size: ["B5"],
    colors: ["Oat", "Charcoal"],
    material: "Textured cardstock, 120 gsm paper, steel coil",
    description: [
      "A generous studio notebook made for sketches, working sessions, and notes that need room to breathe.",
      "The sturdy twin-wire construction folds fully back while a mixed dot-grid and blank layout supports words and visuals equally.",
    ],
    attributes: {
      binding: "Twin-wire spiral",
      ruling: "Alternating dot grid and blank",
      paperWeight: "120 gsm",
      pageCount: "160 pages",
    },
    tags: ["spiral", "studio", "notes", "sketching"],
    Features: [
      "Rigid front and back covers",
      "Micro-perforated pages",
      "Elastic pen keeper",
      "Rounded page corners",
    ],
  },
  {
    id: 11,
    name: "Pocket Travel Notebook",
    category: "Notebooks",
    price: "45.00",
    reviews: "76",
    rating: "4.8",
    image: "/img/generated/product-11.jpg",
    images: ["/img/generated/product-11.jpg"],
    size: ["Pocket"],
    colors: ["Mushroom", "Black"],
    material: "Washable kraft cover and 90 gsm paper",
    description: [
      "A slim, resilient notebook sized for coat pockets, carry-ons, and the smallest corner of a daily bag.",
      "Light gray ruling and a flexible stitched spine make it an easy place to collect addresses, plans, and passing thoughts.",
    ],
    attributes: {
      binding: "Saddle stitched",
      ruling: "6 mm ruled",
      paperWeight: "90 gsm",
      pageCount: "64 pages",
    },
    tags: ["pocket", "travel", "portable", "notebook"],
    Features: [
      "Water-resistant flexible cover",
      "Compact 3.5 × 5.5 inch format",
      "Center-sewn binding",
      "Packaged in a recyclable paper band",
    ],
  },
  {
    id: 12,
    name: "Memo Tear-Off Pad",
    category: "Desk Notes",
    price: "47.00",
    reviews: "111",
    rating: "4.8",
    image: "/img/generated/product-12.jpg",
    images: ["/img/generated/product-12.jpg"],
    size: ["A6"],
    colors: ["Ivory"],
    material: "Responsibly sourced 100 gsm paper with recycled chipboard backing",
    description: [
      "A desk-side memo pad with quiet sections for today, later, and a single note to remember.",
      "Crisp tear-off sheets keep small plans visible, portable, and satisfyingly separate from the rest of your notebook.",
    ],
    attributes: {
      format: "Glued tear-off pad",
      layout: "Priorities, tasks, notes",
      paperWeight: "100 gsm",
      sheetCount: "50 sheets",
    },
    tags: ["memo", "desk pad", "tasks", "best-seller", "minimal"],
    Features: [
      "Smooth fountain-pen-friendly stock",
      "Heavy recycled backing board",
      "Clean micro-glued edge",
      "Soy-based gray ink",
    ],
  },
  {
    id: 13,
    name: "Neutral Page Flags",
    category: "Desk Notes",
    price: "45.00",
    reviews: "149",
    rating: "4.9",
    image: "/img/generated/product-13.jpg",
    images: ["/img/generated/product-13.jpg"],
    size: ["Slim"],
    colors: ["Oat", "Taupe", "Clay", "Smoke", "Ink"],
    material: "Translucent PET film with removable adhesive",
    description: [
      "Five graduated neutrals for marking references, indexing sections, and calling attention without overwhelming the page.",
      "The translucent film accepts ballpoint, gel, and permanent ink while leaving printed text visible beneath.",
    ],
    attributes: {
      quantity: "Five colors",
      flagsPerColor: "40",
      finish: "Writable matte",
      adhesive: "Removable and repositionable",
    },
    tags: ["page flags", "neutral", "indexing", "stationery"],
    Features: [
      "Two hundred flags total",
      "Low-tack page-safe adhesive",
      "Translucent writable surface",
      "Reusable storage card",
    ],
  },
  {
    id: 14,
    name: "Architecture Sticky Notes",
    category: "Desk Notes",
    price: "46.00",
    reviews: "64",
    rating: "4.7",
    image: "/img/generated/product-14.jpg",
    images: ["/img/generated/product-14.jpg"],
    size: ["3 × 3 in"],
    colors: ["Warm White"],
    material: "Responsibly sourced paper with water-based adhesive",
    description: [
      "A geometric sticky-note set inspired by floor plans, drafting marks, and the measured calm of modern architecture.",
      "Fine gray guides create flexible zones for diagrams, short lists, annotations, and quick spatial thinking.",
    ],
    attributes: {
      quantity: "Three pads",
      sheetsPerPad: "40",
      print: "Three architectural grid designs",
      adhesive: "Water-based removable strip",
    },
    tags: ["sticky notes", "architecture", "grid", "desk"],
    Features: [
      "Three complementary layouts",
      "Clean-removal adhesive",
      "Recyclable paper wrap",
      "Designed for pencil, ballpoint, and gel ink",
    ],
  },
  {
    id: 15,
    name: "Magnetic Pen Loop",
    category: "Planner Accessories",
    price: "49.00",
    reviews: "93",
    rating: "4.8",
    image: "/img/generated/product-15-v2.png",
    images: ["/img/generated/product-15-v2.png"],
    size: ["One size"],
    colors: ["Espresso", "Bone", "Black"],
    material: "Vegan leather, elastic, concealed magnets",
    description: [
      "A slim magnetic loop that slips over a planner cover and keeps a favorite pen exactly where it belongs.",
      "The leather-wrapped clasp feels considered from every angle, with a flexible loop that holds most standard writing tools.",
    ],
    attributes: {
      attachment: "Concealed magnetic clasp",
      penDiameter: "8–13 mm",
      coverThickness: "Up to 4 mm",
      orientation: "Left or right edge",
    },
    tags: ["pen loop", "magnetic", "planner accessory", "leather"],
    Features: [
      "No adhesive required",
      "Soft lining protects planner covers",
      "Flexible elastic loop",
      "Coordinates with Forma agendas",
    ],
  },
  {
    id: 16,
    name: "Brass Planner Discs",
    category: "Planner Accessories",
    price: "65.00",
    reviews: "79",
    rating: "4.9",
    image: "/img/generated/product-16-v2.png",
    images: ["/img/generated/product-16-v2.png"],
    size: ["24 mm", "32 mm"],
    colors: ["Brushed Brass"],
    material: "Solid brass",
    description: [
      "Weighty solid-brass discs that add warmth and permanence to a modular planning system.",
      "Each piece is precision turned and softly brushed, developing a distinctive patina through years of daily use.",
    ],
    attributes: {
      quantity: "Set of eight",
      diameter: "24 mm or 32 mm",
      capacity: "Approximately 100 or 160 sheets",
      fit: "Standard mushroom-punched pages",
    },
    tags: ["brass", "planner discs", "discbound", "upgrade"],
    Features: [
      "Machined from solid brass",
      "Smooth page-turning edge",
      "Natural living finish",
      "Cotton storage pouch included",
    ],
  },
  {
    id: 17,
    name: "Matte Black Rollerball",
    category: "Writing Tools",
    price: "68.00",
    reviews: "132",
    rating: "4.9",
    image: "/img/generated/product-17.jpg",
    images: ["/img/generated/product-17.jpg"],
    size: ["0.5 mm"],
    colors: ["Matte Black"],
    material: "Anodized aluminum with brass appointments",
    description: [
      "A balanced metal rollerball with a velvety matte finish and an uninterrupted, low-effort ink line.",
      "Its restrained silhouette sits comfortably beside any planning system and feels substantial without becoming heavy.",
    ],
    attributes: {
      tip: "0.5 mm rollerball",
      ink: "Black archival pigment",
      refill: "Standard Euro-style rollerball",
      mechanism: "Snap cap",
    },
    tags: ["pen", "rollerball", "black", "best-seller", "writing"],
    Features: [
      "Weighted aluminum barrel",
      "Low-glare matte finish",
      "Replaceable black refill",
      "Presentation sleeve included",
    ],
  },
  {
    id: 18,
    name: "Taupe Highlighter Set",
    category: "Writing Tools",
    price: "52.00",
    reviews: "157",
    rating: "4.8",
    image: "/img/generated/product-18.jpg",
    images: ["/img/generated/product-18.jpg"],
    size: ["Dual tip"],
    colors: ["Sand", "Taupe", "Mushroom", "Dust", "Graphite"],
    material: "Water-based ink in recycled polypropylene barrels",
    description: [
      "Five muted highlighters selected to add hierarchy to a page while preserving a quiet neutral palette.",
      "A fine brush point and a broad chisel tip make it easy to move between delicate underlining and wider emphasis without bleeding through most planner paper.",
    ],
    attributes: {
      quantity: "Set of five",
      tip: "Fine brush and 1–4 mm chisel",
      ink: "Water-based, quick drying",
      barrel: "Recycled polypropylene",
    },
    tags: ["highlighters", "taupe", "neutral", "writing"],
    Features: [
      "Five tonal neutral shades",
      "Dual-ended brush and chisel tips",
      "Low-odor water-based ink",
      "Reusable storage case",
    ],
  },
  {
    id: 19,
    name: "Leather Zip Pouch",
    category: "Storage & Desk",
    price: "58.00",
    reviews: "88",
    rating: "4.8",
    image: "/img/generated/product-19.jpg",
    images: ["/img/generated/product-19.jpg"],
    size: ["Small", "Large"],
    colors: ["Cocoa", "Black"],
    material: "Full-grain leather with cotton twill lining",
    description: [
      "A softly structured leather pouch for pens, clips, charging cords, and the small tools that make a workspace personal.",
      "The wide zip opening reveals a light cotton interior, making every item easy to see and retrieve.",
    ],
    attributes: {
      closure: "Polished metal zipper",
      lining: "Natural cotton twill",
      smallDimensions: "7 × 2.5 × 2 in",
      largeDimensions: "9 × 3.5 × 2.5 in",
    },
    tags: ["pouch", "leather", "pen case", "organization"],
    Features: [
      "Full-width gusseted opening",
      "Wipe-clean cotton lining",
      "Hand-painted leather edges",
      "Embossed mark on base only",
    ],
  },
  {
    id: 20,
    name: "Acrylic Inbox Tray",
    category: "Storage & Desk",
    price: "48.00",
    reviews: "54",
    rating: "4.7",
    image: "/img/generated/product-20.jpg",
    images: ["/img/generated/product-20.jpg"],
    size: ["Letter"],
    colors: ["Smoke", "Clear"],
    material: "Cast acrylic with silicone feet",
    description: [
      "A low-profile acrylic tray that gathers correspondence, loose pages, and current projects into one deliberate place.",
      "Its translucent smoke finish creates visual depth while allowing the tray to disappear quietly into a composed desk.",
    ],
    attributes: {
      capacity: "Letter and A4 documents",
      dimensions: "12.5 × 9.5 × 2 in",
      thickness: "4 mm cast acrylic",
      base: "Four non-slip silicone feet",
    },
    tags: ["inbox", "acrylic", "desk organization", "smoke"],
    Features: [
      "Hand-polished edges",
      "Stackable profile",
      "Protective non-slip feet",
      "Ships in recyclable molded pulp",
    ],
  },
  {
    id: 21,
    name: "Brass Page Clips",
    category: "Planner Accessories",
    price: "54.00",
    reviews: "116",
    rating: "4.9",
    image: "/img/generated/product-21-v2.png",
    images: ["/img/generated/product-21-v2.png"],
    size: ["One size"],
    colors: ["Brushed Brass"],
    material: "Spring brass",
    description: [
      "Six compact brass clips that mark a current page, gather loose notes, or hold a photograph without unnecessary bulk.",
      "Their softened edges protect paper, while the brushed living finish grows warmer and more individual with use.",
    ],
    attributes: {
      quantity: "Set of six",
      shapes: "Six rounded geometric profiles",
      capacity: "Up to 12 sheets",
      finish: "Brushed living brass",
    },
    tags: ["page clips", "brass", "bookmark", "planner accessory"],
    Features: [
      "Six complementary geometric forms",
      "Smooth hand-finished edges",
      "Low-profile page marker",
      "Cotton storage envelope included",
    ],
  },
  {
    id: 22,
    name: "The Clarity Edit Set",
    category: "Gift Sets",
    price: "96.00",
    reviews: "61",
    rating: "4.9",
    image: "/img/generated/product-22.jpg",
    images: ["/img/generated/product-22.jpg"],
    size: ["Curated set"],
    colors: ["Warm Neutral"],
    material: "Paper, aluminum, recycled board, cotton ribbon",
    description: [
      "A considered introduction to intentional planning, arranged as a tactile ritual for beginning again.",
      "The keepsake box pairs a six-month planner with a metal pen, page flags, and guided reflection cards in a restrained neutral palette.",
    ],
    attributes: {
      contents: "Planner, rollerball, page flags, 12 reflection cards",
      plannerFormat: "Undated A5 weekly",
      packaging: "Rigid reusable keepsake box",
      gifting: "Blank message card included",
    },
    tags: ["gift set", "planning", "intention", "new", "curated"],
    Features: [
      "Four-piece coordinated collection",
      "Ready-to-gift cotton ribbon wrap",
      "Reusable archival box",
      "Printed welcome and care guide",
    ],
  },
  {
    id: 23,
    name: "Routine Card Set",
    category: "Desk Notes",
    price: "58.00",
    reviews: "70",
    rating: "4.8",
    image: "/img/generated/product-23-v2.png",
    images: ["/img/generated/product-23-v2.png"],
    size: ["A6"],
    colors: ["Ivory", "Warm Gray"],
    material: "Responsibly sourced 350 gsm uncoated cardstock",
    description: [
      "Reusable prompt cards for shaping morning, evening, weekly, and seasonal routines with clarity rather than rigidity.",
      "Each card combines a concise reflection cue with an open grid for creating a ritual that belongs to you.",
    ],
    attributes: {
      quantity: "24 cards",
      cardSize: "A6",
      cardStock: "350 gsm uncoated",
      storage: "Recycled board slipcase",
    },
    tags: ["routine", "prompt cards", "reflection", "new", "habits"],
    Features: [
      "Twenty-four original planning prompts",
      "Writable front and back",
      "Rounded hand-friendly corners",
      "Numbered cards for easy reference",
    ],
  },
  {
    id: 24,
    name: "Linen Desk Folio",
    category: "Storage & Desk",
    price: "84.00",
    reviews: "47",
    rating: "4.9",
    image: "/img/generated/product-24.jpg",
    images: ["/img/generated/product-24.jpg"],
    size: ["A4 / Letter"],
    colors: ["Natural Linen", "Charcoal Linen"],
    material: "Natural woven linen, recycled board, microsuede lining",
    description: [
      "A linen-covered folio that turns loose papers, proposals, and meeting notes into a polished working set.",
      "Its book-like profile opens flat to reveal two document wings and a discreet pen channel, then closes neatly for travel or shelf storage.",
    ],
    attributes: {
      format: "Book-style document folio",
      capacity: "Up to 40 sheets",
      dimensions: "12.4 × 9.6 × 0.75 in",
      closure: "Concealed magnetic edge",
    },
    tags: ["folio", "linen", "desk", "sale", "documents"],
    Features: [
      "Two expandable document pockets",
      "Integrated pen channel",
      "Soft microsuede interior",
      "Hand-wrapped archival construction",
    ],
  },
  {
    id: 25,
    name: "Walnut Desktop Caddy",
    category: "Storage & Desk",
    price: "68.00",
    reviews: "39",
    rating: "4.8",
    image: "/img/generated/product-25.png",
    images: ["/img/generated/product-25.png"],
    size: ["Compact"],
    colors: ["Natural Walnut"],
    material: "Solid walnut with a plant-based matte oil finish",
    description: [
      "A compact three-tier caddy that keeps memo cards, pens, and the small tools of a working desk visible without creating clutter.",
      "Each stepped compartment is sized for everyday stationery, with softened edges and a stable footprint that sits comfortably beside a laptop or planner.",
      "Natural walnut grain makes every piece subtly individual, while the low-sheen finish can be wiped clean and refreshed as the wood develops character over time.",
    ],
    attributes: {
      format: "Three-compartment desktop organizer",
      dimensions: "18 × 11 × 12 cm",
      finish: "Plant-based matte hardwax oil",
      care: "Wipe with a soft, dry cloth",
    },
    tags: ["desk organizer", "walnut", "storage", "new", "workspace"],
    Features: [
      "Three stepped storage compartments",
      "Solid wood with naturally varied grain",
      "Softly rounded hand-finished edges",
      "Felt base pads protect desk surfaces",
    ],
  },
  {
    id: 26,
    name: "Linen Archive Box — Stone",
    category: "Storage & Desk",
    price: "76.00",
    reviews: "32",
    rating: "4.8",
    image: "/img/generated/product-26.png",
    images: ["/img/generated/product-26.png"],
    size: ["A4 / Letter"],
    colors: ["Stone Linen"],
    material: "Natural woven linen and archival recycled board",
    description: [
      "A tailored linen box for gathering project papers, letters, and finished planning inserts into one quiet archive.",
      "The fitted lift-off lid protects its contents while the softly structured profile sits comfortably on an open shelf or desktop.",
    ],
    attributes: {
      format: "Lidded document box",
      capacity: "Up to 350 sheets",
      dimensions: "12.6 × 9.8 × 2.4 in",
      interior: "Acid-free paper lining",
    },
    tags: ["archive", "linen", "storage", "new", "documents"],
    Features: [
      "Hand-wrapped woven linen exterior",
      "Rigid archival board construction",
      "Protective fitted lid",
      "Acid-free lined interior",
    ],
  },
  {
    id: 27,
    name: "Habit Rhythm Inserts — A5",
    category: "Planner Inserts",
    price: "46.00",
    reviews: "57",
    rating: "4.8",
    image: "/img/generated/product-27.png",
    images: ["/img/generated/product-27.png"],
    size: ["A5"],
    colors: ["Soft White"],
    material: "Responsibly sourced 120 gsm paper",
    description: [
      "A flexible monthly tracker for noticing the small routines that shape a week without turning progress into pressure.",
      "Open grids, a brief reflection area, and an undated format make each sheet useful for wellness, creative practice, or focused work.",
    ],
    attributes: {
      format: "Six-hole punched inserts",
      layout: "Undated monthly habit grid",
      paperWeight: "120 gsm",
      pageCount: "24 pages / 12 months",
    },
    tags: ["habits", "tracker", "A5", "inserts", "new", "undated"],
    Features: [
      "Twelve undated monthly trackers",
      "Space for eight recurring habits",
      "Monthly notes and reflection area",
      "Fits standard A5 six-ring agendas",
    ],
  },
  {
    id: 28,
    name: "Brass Measure Bookmark",
    category: "Planner Accessories",
    price: "34.00",
    reviews: "44",
    rating: "4.7",
    image: "/img/generated/product-28.png",
    images: ["/img/generated/product-28.png"],
    size: ["A5 / Personal"],
    colors: ["Satin Brass"],
    material: "Solid brass with a hand-brushed satin finish",
    description: [
      "A slim page marker, ruler, and stencil in one considered brass tool that slips neatly into a planner pocket.",
      "Subtle measuring marks and simple geometric apertures support quick layouts while the rounded tab keeps an active page easy to find.",
    ],
    attributes: {
      format: "Ruler, stencil, and bookmark",
      length: "15 cm / 6 in",
      thickness: "0.8 mm",
      finish: "Hand-brushed satin",
    },
    tags: ["brass", "bookmark", "ruler", "stencil", "planner tool"],
    Features: [
      "Metric and imperial guide marks",
      "Four geometric stencil shapes",
      "Rounded integrated page tab",
      "Naturally develops a warm patina",
    ],
  },
  {
    id: 29,
    name: "Quiet Tone Washi Set",
    category: "Planner Accessories",
    price: "28.00",
    reviews: "83",
    rating: "4.9",
    image: "/img/generated/product-29.png",
    images: ["/img/generated/product-29.png"],
    size: ["15 mm"],
    colors: ["Neutral Assortment"],
    material: "Matte Japanese washi paper and low-tack adhesive",
    description: [
      "Five tonal paper tapes for marking sections, building simple keys, and adding quiet layers to everyday pages.",
      "The low-tack adhesive lifts cleanly for repositioning, while each matte neutral is easy to write over with pencil or pen.",
    ],
    attributes: {
      quantity: "Set of five rolls",
      width: "15 mm",
      length: "10 m per roll",
      adhesive: "Repositionable low-tack",
    },
    tags: ["washi", "tape", "neutral", "journaling", "new"],
    Features: [
      "Five coordinated neutral tones",
      "Tears cleanly by hand",
      "Writable matte surface",
      "Repositionable without residue",
    ],
  },
  {
    id: 30,
    name: "Pebble Leather Pencil Case",
    category: "Storage & Desk",
    price: "64.00",
    reviews: "41",
    rating: "4.9",
    image: "/img/generated/product-30.png",
    images: ["/img/generated/product-30.png"],
    size: ["Slim"],
    colors: ["Black"],
    material: "Full-grain pebbled leather and antique brass hardware",
    description: [
      "A compact leather case that carries daily pens, pencils, and small planning tools without unnecessary bulk.",
      "The structured silhouette protects its contents while soft cotton lining and a wide zip opening keep every tool easy to reach.",
    ],
    attributes: {
      format: "Zip pencil case",
      capacity: "Up to 8 writing tools",
      dimensions: "19 × 5 × 4 cm",
      interior: "Soft cotton twill lining",
    },
    tags: ["pencil case", "leather", "storage", "black", "new"],
    Features: [
      "Full-grain leather exterior",
      "Antique brass zip closure",
      "Wipe-clean cotton lining",
      "Compact structured profile",
    ],
  },
  {
    id: 31,
    name: "Perpetual Desk Calendar",
    category: "Desk Notes",
    price: "59.00",
    reviews: "36",
    rating: "4.8",
    image: "/img/generated/product-31-v2.png",
    images: ["/img/generated/product-31-v2.png"],
    size: ["Desktop"],
    colors: ["Ivory / Walnut"],
    material: "Solid walnut and responsibly sourced 350 gsm cotton paper",
    description: [
      "A reusable desk calendar that brings the current month into view without adding visual noise to the workspace.",
      "The undated card system can begin in any year, then returns to its solid walnut stand as each month moves forward.",
    ],
    attributes: {
      format: "Undated monthly card calendar",
      quantity: "Twelve double-sided month cards",
      cardSize: "A6",
      base: "Hand-finished solid walnut",
    },
    tags: ["calendar", "desk", "perpetual", "walnut", "new"],
    Features: [
      "Reusable undated monthly cards",
      "Sunday and Monday start layouts",
      "Thick rounded-corner cotton stock",
      "Solid walnut display stand",
    ],
  },
];

const categoryDetail = {
  Planners:
    "Designed as a long-term planning companion, it balances durable construction with a quiet visual language that works at home, in the studio, or in a meeting.",
  "Planner Inserts":
    "The paper is selected for comfortable everyday writing and the layout leaves breathing room, so appointments, lists, and reflections remain easy to scan.",
  "Dividers & Dashboards":
    "Made to layer cleanly into an existing system, every edge, tab, and punched detail is considered for frequent handling without unnecessary bulk.",
  Notebooks:
    "Thoughtful binding, balanced paper tone, and practical page proportions make it equally useful for structured work, quick notes, and longer-form thinking.",
  "Desk Notes":
    "Its compact format keeps active thoughts close at hand, while neutral color and restrained printing sit comfortably within a calm workspace.",
  "Planner Accessories":
    "The piece is proportioned for daily use and finished to coordinate with both ring and discbound systems without drawing attention away from the page.",
  "Writing Tools":
    "Balanced in the hand and straightforward to use, it is intended for clear everyday marks across planners, notebooks, and loose project sheets.",
  "Storage & Desk":
    "The practical silhouette is easy to place on shelves or work surfaces, with durable materials chosen to age gracefully through regular use.",
  "Gift Sets":
    "Every element is selected to work together from the first use, and the reusable presentation packaging keeps the set organized between planning sessions.",
};

const enrichedProductData = productData.map((product) => ({
  ...product,
  description: categoryDetail[product.category]
    ? [...product.description, categoryDetail[product.category]]
    : product.description,
}));

export default enrichedProductData;
